import { catchError } from 'rxjs/operators';
import { handleError } from '../services/helpers/api-error-handler.helper';

export function ApiMethod(): MethodDecorator {
	// tslint:disable-next-line:ban-types
	return (target: Function, key: string, descriptor: any) => {

		const originalMethod = descriptor.value;

		// tslint:disable-next-line:only-arrow-functions
		descriptor.value = function(...args: any[]) {
			const result = originalMethod.call(this, ...args)
				.pipe(catchError(err => handleError(err)));
			return result;
		};

		return descriptor;
	};
}
